import { render } from "./NewStorageConfigurationModal.vue?vue&type=template&id=1b9a431d&ts=true"
import script from "./NewStorageConfigurationModal.vue?vue&type=script&lang=ts"
export * from "./NewStorageConfigurationModal.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__